import React from 'react';
import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { testimonials as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    shouldUseRewardCountValue: true,
    carousel: {
      loop: true,
      align: 'center',
      hasArrows: false,
      hasDots: true,
      playOnInit: true,
      stopOnMouseEnter: true,
      breakpoints: {
        m: { hasArrows: false, hasDots: true },
        l: { hasArrows: true },
      },
    },
    getSectionTitle: (rewardCount, earnType) => (
      <>Join members earning {rewardCount} {earnType} on average annually<span className="mn_dot">.</span></>
    ),
    checkShouldUseCarousel: () => (false),
    checkShouldShowIconInCarousel: () => (false),
    checkShouldShowIconInSlide: () => (false),
    testimonialsCopy: [],
  },
  hiw: {
    getSectionTitle: () => (<>What our members are saying</>),
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
